import { Capacitor } from '@capacitor/core';

// I note that in desktop mode you can always see the map, so we let this slide for those users

const isMapVisible = () => {
  if (Capacitor.isNativePlatform()) {
    return ['/maps', '/maps/trips/active'].includes(window.location.pathname);
  }
  return true;
};

export { isMapVisible as default };
